<template>
  <!-- 外面的盒子 -->
  <div class="wrap-result container">    
      <div class="header-box">
        <div class="userInfo" v-for="(item,index) in infoList" :key="index" @click="toDetail(item.reportUid)">
          <div class="item firstItem">
            <i>{{item.userName}}</i>            
            <span>{{item.userAge}}岁</span>
          </div>
          <div class="item">
            <span>体检类型：</span>
            <span>{{item.reportTypeName}}</span>
            <div class="list"></div>
          </div>
          <div class="item">
            <span>体检时间：</span>
            <span>{{item.reportDateStr}}</span>
          </div>
        </div>
      </div>    
	  
    <div class="content" v-if="infoList.length==0">
    	请联系工作人员，上传体检报告<br/>
    	咨询热线：<a href="tel:0731-85555112" style="color: #007AFF;">0731-85555112</a>
    </div>      
  </div>
</template>

<script>
import { getApi, postApi } from '../../api/index.js'
export default {
  components: {    
  },
  data() {
    return {      
      infoList: []
    }
  },
  methods: {
    getPhysicalList() {
      getApi({ url: '/physical/list', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              let arr = res.data;
              this.infoList = arr;              
            }
          }
        })
        .catch(res => {})
    },   
    toDetail(reportUid) {
      this.$router.push({
        path: '/xiyiDetail',
        query: { reportUid: reportUid}
      })
    }
  },
  created() {
	  this.getPhysicalList();
  }
}
</script>
<style lang="less" scoped>
.content{
	font-size: 0.3rem;
	line-height: 0.5rem;
	padding: 0.2rem;
}
.wrap-result {
  background-size: 100%;
  width: 100%;
  height: 100%;
  .header-box {
    // height: 100%;
    padding-bottom: 0.98rem;
    // overflow: hidden;
    // text-align: center;
    background: #eff3f4;
    overflow: hidden;
    border: 0px;
  }
}
.userInfo {
  width: 100%;
  height: 2rem;
  box-sizing: border-box;
  padding: 0.34rem 0.33rem 0 0.32rem;
  background: #fff;
  margin-bottom: 0.16rem;
  .item {
    width: 100;
    height: 0.25rem;
    line-height: 0.25rem;
    margin-top: 0.27rem;
    i {
      font-weight: 400;
      font-size: 0.34rem;
      margin-right: 0.14rem;
    }
    span {
      font-size: 0.26rem;
      color: rgb(102, 102, 102);
    }
    .list {
      width: 0.36rem;
      height: 0.4rem;
      float: right;
      background-image: url(../../assets/image/resultList/res.png);
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
  .firstItem {
    height: 0.32rem;
    margin-top: 0;
    // line-height: .32rem;
    span {
      margin-right: 0.16rem;
    }
  }
}

.foot {
  position: fixed;
  bottom: 0;
  width: 100%;  
  text-align: center;
  background: #fff;
  padding: 0.2rem;
  box-sizing: border-box;
  z-index: 99;
}
</style>
